export interface AnsibleInfo {
  id: string
  name: string
  terminalId: string
  status: string
}

export interface PnsMacMini {
  id: string
  name: string
  model: string
  serialNumber: string
  macAddress: string
  osVersion: string
  primaryIp?: string
  cpuUsage?: number
  memoryUsage?: number
  diskUsage?: number
  maxUsers: number
  currentUsers: number
  status: PnsMacMiniStatus
  ansibleId?: string
  ansible?: AnsibleInfo
  terminalId?: string
  lastHealthCheck?: string
  lastAnsibleChange?: string
  lastRestartAt?: string
  createdAt: string
  updatedAt: string
  macMiniUsers?: import('./pns-mac-mini-user').PnsMacMiniUser[]
  userIds: string[]
  availableUserSlots: number
  isAvailable: boolean
}

export enum PnsMacMiniStatus {
  RECEIVED = 'RECEIVED',
  PROVISIONING = 'PROVISIONING',
  AVAILABLE = 'AVAILABLE',
  ACTIVE = 'ACTIVE',
  MAINTENANCE = 'MAINTENANCE',
  RELOCATING = 'RELOCATING',
  OFFLINE = 'OFFLINE',
  DECOMMISSIONED = 'DECOMMISSIONED',
}

export interface PaginatedPnsMacMiniResponse {
  data: PnsMacMini[]
  pagination: {
    total: number
    count: number
    limit: number
    offset: number
    hasMore: boolean
    currentPage: number
    totalPages: number
  }
}

export interface PnsMacMiniCountResponse {
  total: number
  byStatus: {
    [key in PnsMacMiniStatus]: number
  }
}

export interface PnsMacMiniHealthResponse {
  id: string
  status: PnsMacMiniStatus
  cpuUsage?: number
  memoryUsage?: number
  diskUsage?: number
  lastHealthCheck?: string
  isHealthy: boolean
}
